import Vue from "vue";
import Vuex from "vuex";
import axios from "axios"
import config from "./config"

Vue.use(Vuex);
var setFormData = function(data){
    var params = new FormData();
    for(var key in data){
        if(data[key]!==null&&data[key]!==undefined){
            params.append(key, data[key]);
        }
    }
    return params;
}
export default new Vuex.Store({
  state: {
    userInfo: JSON.parse(sessionStorage.getItem("userInfo")) || {},
    pageTitle: 'login',
    edit:false,
    pagesizeForm:10,
    warning: {
      warningMsg: "",
      warningFalg: false,
      button: []
    },
    keywordObj:{
      groupFalg:false,
      button:[],
    },
    promotionObj:{
      groupFalg:false,
      button:[],
    },
    submenuObj:{
      groupFalg:false,
      button:[],
    },
    language:[],

    onlineSubmissionSearchParam:{
      EntryNumber1:'',
      EntryNumber2:'',
      SubmissionDate:[],
      pageIndex:1,
      pageSize:10,
      keywords:'',
      searchStatus:'',
      SubmissionID:"",
      submissionType:1,
      rating:"",
      level:"",
      sortName:"",
      sortType:""
    },
    physicalSubmissionSearchParam:{
      EntryNumber1:'',
      EntryNumber2:'',
      SubmissionDate:[],
      pageIndex:1,
      pageSize:10,
      keywords:'',
      searchStatus:'',
      SubmissionID:"",
      submissionType:2,
      rating:"",
      level:"",
      sortName:"",
      sortType:""
    },
    batchSubmissionSearchParam:{
      EntryNumber1:'',
      EntryNumber2:'',
      SubmissionDate:[],
      pageIndex:1,
      pageSize:10,
      keywords:'',
      searchStatus:'',
      SubmissionID:"",
      submissionType:4,
      rating:"",
      level:"",
      sortName:"",
      sortType:""
    },
    hsbcOnlineSubmissionSearchParam:{
      EntryNumber1:'',
      EntryNumber2:'',
      SubmissionDate:[],
      pageIndex:1,
      pageSize:10,
      keywords:'',
      searchStatus:'',
      SubmissionID:"",
      submissionType:3,
      rating:"",
      level:"",
      sortName:"",
      sortType:""
    },
  },
  mutations: {
    setOnlineSubmissionSearchParam(state, data){
      state.onlineSubmissionSearchParam = data
    },
    setPhysicalSubmissionSearchParam(state, data){
      state.physicalSubmissionSearchParam = data
    },
    setBatchSubmissionSearchParam(state, data){
      state.batchSubmissionSearchParam = data
    },
    setHsbcOnlineSubmissionSearchParam(state, data){
      state.hsbcOnlineSubmissionSearchParam = data
    },
    setPageTitle(state, string) {
      state.pageTitle = string;
    },
    setwarning(state, data) {
      state.warning.warningMsg = data.string;
      state.warning.warningFalg = data.boolean;
      state.warning.button = data.button;
    },
    setkeywordlist(state, data) {
      state.keywordObj.groupFalg = data.boolean;
      state.keywordObj.callback = data.callback;
      state.keywordObj.button = data.button;
      state.keywordObj.pageLongCode = data.pageLongCode;
    },
    setlandinglist(state, data) {
      state.promotionObj.groupFalg = data.boolean;
      state.promotionObj.callback = data.callback;
      state.promotionObj.button = data.button;
      state.promotionObj.type = data.type;
    },
    setsubmenulist(state, data) {
      state.submenuObj.groupFalg = data.boolean;
      state.submenuObj.callback = data.callback;
      state.submenuObj.button = data.button;
    },
    login(state, userInfo) {
        Vue.set(state, 'userInfo', userInfo);
        sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
    }
  },
  getters:{
    warning: state => state.warning,

  },
  actions: {
        async login(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/login`, data);
                    
                    if (result.data.status_code === "0") {
                        context.commit("login", result.data.result);
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.status_message,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){
                                context.commit("setwarning", { string: "", boolean: false });
                              }
                            }]
                        })
                        resolve(false)
                    }
                } catch (err) {
                    reject(err)
                }
            })
        },
        async apiEvent(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    var url = data.apiUrl;
                    delete data ['apiUrl']
                    let result = await axios.post(`${config.domain}`+ url, data)
                    if (result.data.status_code == "0") {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.status_message,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){context.commit("setwarning", { string: "", boolean: false });}
                            }]
                        })
                        if(result.data.status_code == "000104"||result.data.status_code == "000105"){
                          resolve("000104")
                        }else{
                          resolve(false)
                        }
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
        async apiGetEvent(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    var url = data.apiUrl;
                    delete data ['apiUrl']
                    data.userId = context.state.userInfo.userId
                    data.token = context.state.userInfo.token
                    const keys = Object.keys(data)
                    keys.forEach((i,index)=>{
                      if(index == 0) url += '?'
                      if(index == keys.length - 1)url +=`${i}=${data[i]}`
                      else url +=`${i}=${data[i]}&`
                    })
                    
                    let result = await axios.get(`${config.domain}`+ url, data)

                    if (result.data.status_code == "0") {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.status_message,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){context.commit("setwarning", { string: "", boolean: false });}
                            }]
                        })
                        if(result.data.status_code == "000104"||result.data.status_code == "000105"){
                          resolve("000104")
                        }else{
                          resolve(false)
                        }
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
        async apiEventFromData(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    var url = data.apiUrl;
                    delete data ['apiUrl'];

                    var domain = `${config.domain}`
                    if(data.apiDomain){
                      domain = data.apiDomain;
                      delete data ['apiDomain'];
                    }
                    
                    let result = await axios.post(domain + url, setFormData(data))
                    
                    if (result.data.status_code == "0") {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.status_message,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){context.commit("setwarning", { string: "", boolean: false });}
                            }]
                        })
                        if(result.data.status_code == "000104"||result.data.status_code == "000105"){
                          resolve("000104")
                        }else{
                          resolve(false)
                        }
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
        async apiEventFromDataDownload(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    var url = data.apiUrl;
                    delete data ['apiUrl'];

                    var domain = `${config.domain}`
                    if(data.apiDomain){
                      domain = data.apiDomain;
                      delete data ['apiDomain'];
                    }
                    
                    let result = await axios.post(domain + url, setFormData(data), {
                      headers: {
                          'Content-Type': 'application/x-www-form-urlencoded',
                       },
                      'responseType': 'blob' 
                    })
                    if (result.data.status_code == "0"||result.data.status_code == undefined) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.status_message,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){context.commit("setwarning", { string: "", boolean: false });}
                            }]
                        })
                        if(result.data.status_code == "000104"||result.data.status_code == "000105"){
                          resolve("000104")
                        }else{
                          resolve(false)
                        }
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
  },
  modules: {
  }
});
